module.exports = __webpack_public_path__ + "img/st-logo-mini.7ab4f7cb.svg";